import React from 'react';
import './Terms.css';

function Terms() {
  return (
    <div className="terms-page">
      <div className="container">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>Acceptance of Terms</h2>
          <p>By accessing and using Herding Helpers, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>
        </section>

        <section>
          <h2>Description of Service</h2>
          <p>Herding Helpers is a platform that connects farmers, ranchers, and agricultural producers with local helpers for emergency situations and routine assistance. Our service facilitates communication and coordination between users but does not directly provide agricultural services.</p>
        </section>

        <section>
          <h2>User Responsibilities</h2>
          <p>As a user of Herding Helpers, you agree to:</p>
          <ul>
            <li>Provide accurate and truthful information in your profile</li>
            <li>Use the platform only for legitimate agricultural assistance purposes</li>
            <li>Treat all users with respect and professionalism</li>
            <li>Comply with all applicable local, state, and federal laws</li>
            <li>Not use the service for any illegal or unauthorized purpose</li>
            <li>Maintain the confidentiality of your account credentials</li>
          </ul>
        </section>

        <section>
          <h2>Emergency Services</h2>
          <p>While Herding Helpers facilitates emergency alerts and communication, it is not a substitute for official emergency services. In case of life-threatening emergencies, always contact 911 or your local emergency services first.</p>
        </section>

        <section>
          <h2>Limitation of Liability</h2>
          <p>Herding Helpers acts as a platform to connect users and is not responsible for:</p>
          <ul>
            <li>The quality, safety, or legality of services provided by helpers</li>
            <li>The accuracy of user-provided information</li>
            <li>Any damages or losses resulting from interactions between users</li>
            <li>Equipment failures, property damage, or personal injury</li>
            <li>Delays in emergency response or communication</li>
          </ul>
        </section>

        <section>
          <h2>User Content and Conduct</h2>
          <p>Users are solely responsible for content they post and their conduct on the platform. Prohibited activities include:</p>
          <ul>
            <li>Posting false, misleading, or fraudulent information</li>
            <li>Harassment, discrimination, or abusive behavior</li>
            <li>Sharing inappropriate or offensive content</li>
            <li>Attempting to circumvent platform security measures</li>
            <li>Using the platform for commercial solicitation unrelated to agricultural assistance</li>
          </ul>
        </section>

        <section>
          <h2>Account Termination</h2>
          <p>We reserve the right to terminate or suspend accounts that violate these terms, engage in prohibited conduct, or pose a risk to the safety and security of our community.</p>
        </section>

        <section>
          <h2>Modifications to Terms</h2>
          <p>Herding Helpers reserves the right to modify these terms at any time. Users will be notified of significant changes, and continued use of the service constitutes acceptance of modified terms.</p>
        </section>

        <section>
          <h2>Governing Law</h2>
          <p>These terms shall be governed by and construed in accordance with the laws of the State of Nebraska, without regard to its conflict of law provisions.</p>
        </section>

        <section>
          <h2>Contact Information</h2>
          <p>If you have questions about these Terms of Service, please contact us at:</p>
          <p>Email: legal@herdinghelpers.com<br />
          Phone: (555) 123-4567<br />
          Address: 123 Agricultural Way, Louisville, NE 68037</p>
        </section>
      </div>
    </div>
  );
}

export default Terms;